import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'

function DeleteConfirmationModal({ modalIsOpen, modelId, closeModal }) {
  return (
    <Modal
      isOpen={modalIsOpen}
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal">
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={() => closeModal()}>
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>
        <div className="overlay-modal--content overlay-modal--confirm-item-delete">
          <div className="l-inner-large">
            <div className="u-text-center">
              <p>Are you sure you want to delete this model draft?</p>
              <a href={`/profile/items/${modelId}`} data-method="delete" className="btn btn-outline-default btn-fat u-mr10">
                Confirm deletion
              </a>
              <button className="btn btn-primary btn-fat" onClick={() => closeModal()}>
                Continue editing
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

DeleteConfirmationModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  modelId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default DeleteConfirmationModal
